	import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class JobDescriptionService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('JobDescription');
	}
	
	loadAll(): Observable<ePM.Logic.JobDescription[]> {
		return this.myBaseService.loadAll(this.url);
	}
	save(tempItem: ECI.Basic.ObjectBase): Observable<ePM.Logic.JobDescription> {
		return this.myBaseService.save(tempItem, this.url);
	}
	assign(tempItem: ePM.Logic.DocumentHistoryAssign): Observable<boolean> {
		return this.myBaseService.post(tempItem, this.url + "/Assign");
	}
	restore(id: System.Guid): Observable<ePM.Logic.JobDescription> {
		return this.myBaseService.post(id, this.url + "/Restore");
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<ePM.Logic.JobDescription> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid): Observable<ePM.Logic.JobDescription>{
		return this.myBaseService.get(id, this.url);
	}
	getHistory(id: System.Guid): Observable<ePM.Logic.JobDescription[]> {
		return this.myBaseService.loadAll(this.url + '/History/' + id);
	}

}
